import React, { Component, Fragment } from 'react';
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import PropTypes from "prop-types";
import Navbar from "../common/Navbar";
import Footer from "../common/Footer";
import { getMemberActionIsRead } from "../../actions/memberActions";
import { getBinding, retrieveAccount } from "../../actions/bindActions";
import { isUserAuthenticated } from "../../helpers/authUtils";
import isEmpty from "../../validation/is-empty";

class RetrieveAccount extends Component {
  constructor(props) {
    super(props);

    this.state = {
      role_name: "",
      new_id: "",
      attachments: [],
      error: {},
      showModal: "",
      showModalBackdrop: "",
    };

    this.onChange = this.onChange.bind(this);
    this.onClick = this.onClick.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
  }

  componentDidMount = () => {
    this.props.getMemberActionIsRead();
    const role_id = this.props.match.params.role_id;
    this.props.getBinding(role_id);
  };

  componentDidUpdate(prevProps) {
    if (this.props.errors !== prevProps.errors) {
      this.setState({ error: this.props.errors });
    }

    if (this.props.result !== prevProps.result) {
      if (this.props.result.msg && this.props.result.msg === "Retrieve Account OK") {
        this.setState({ showModal: "show", showModalBackdrop: "modal-backdrop show" });
      }
    }
  };

  handleCloseModal() {
    this.setState({ showModal: "", showModalBackdrop: "" });
    this.props.history.push("/members/bind");
  }

  onClick(e) {
    e.preventDefault();
    const { role_name, new_id, attachments } = this.state;
    const { binding } = this.props;

    let error = {};
    if (isEmpty(role_name)) {
      error.role_name= "請輸入角色暱稱";
    }

    if (isEmpty(new_id)) {
      error.new_id= "請輸入新帳號";
    }
    
    if (attachments.length === 0) {
      error.file= "請上傳檔案";
    }

    if (!isEmpty(error)){
      this.setState({ error: error });
    } else {
      this.setState({ error: {} });

      let formData = new FormData();

      for (let index = 1; index <= attachments.length; index++) {
        formData.append(`attachment${index}`, attachments[index - 1]);
      }

      formData.append("game_id", binding.game_id);
      formData.append("game_name", binding.game_name);
      formData.append("server_id", binding.server_id);
      formData.append("role_id", binding.role_id);
      formData.append("role_name", role_name);
      formData.append("new_id", new_id);
      
      this.props.retrieveAccount(formData);
    }

  };

  onChange(e) {
    //console.log(e.target.name, e.target.value)
    this.setState({ [e.target.name]: e.target.value });

    if (!isEmpty(e.target.files)) {
      this.setState({ attachments: e.target.files });
    }
  }

  renderRedirectToRoot = () => {
    const isAuthTokenValid = isUserAuthenticated();
    if (!isAuthTokenValid) {
      return <Redirect to="/members" />;
    }
  };

  render() {
    const isAuthTokenValid = isUserAuthenticated();
    const { isRead, binding } = this.props;
    const { error, role_name, new_id, showModal, showModalBackdrop } = this.state;
    
    let form = {
      justifyContent: "center",
      display: "grid"
    };

    let formGroup = {
      marginBottom: "25px",
      display: "inline-flex",
      marginLeft: "auto",
      marginRight: "auto"
    };

    let formLabel = {
      color: "#787878",
      margin: "auto 0", 
      width: "6rem"
    };

    let formControl = {
      width: "290px",
      backgroundColor: "#E5E5E5"
    };
    
    let formControlStatic = {
      width: "290px",
      height: "45px",
      padding: "5px 20px",
      borderRadius: "40px",
      border: "1.5px solid #C7C7C7",
    };

    let formControlFile = {
      width: "290px", 
      height: "45px"
    };

    let errorSpan1 = {
      textAlign: "left", 
      margin: "-30px 0 0 100px"
    };

    let errorSpan2 = {
      textAlign: "left", 
      margin: "-60px 0 0 100px"
    };

    return (
      <Fragment>
        {this.renderRedirectToRoot()}
        {(isAuthTokenValid) && (
        <div id="page">
          <Navbar showMenuLine={true} isRead={isRead} />
          <div className="colorlib" style={{backgroundColor: "#fafafa", borderBottom: "1px solid #CBCBCB"}}>
            <div className="container">
              <div className="row">
                  <div className="col-lg-12">
                    <h1 style={{color: "#000", fontWeight: "700", textAlign: "center", margin: "30px 0px 60px"}}>找回遊戲帳號</h1>
                    <div className="form-container">
                      <form style={form}>
                        <div className="form-group" style={formGroup}>
                          <label style={formLabel}>伺服器</label>
                          <input id="server_id" name="server_id" type="text" className="form-control" style={formControl} value={binding.server_name} disabled />
                        </div>
                        <div className="form-group" style={formGroup}>
                          <label style={formLabel}>角色ID</label>
                          <input id="role_id" name="role_id" type="text" className="form-control" style={formControl} value={binding.role_id} disabled />
                        </div>
                        <div className="form-group" style={formGroup}>
                          <label htmlFor="role_name" style={formLabel}>角色暱稱</label>
                          <input id="role_name" name="role_name" type="text" className="form-control" style={formControlStatic} value={role_name} onChange={this.onChange} />
                        </div>
                        {error.role_name && (
                          <span className="wrong_msg" style={errorSpan1}><img src="../img/icon_wrong.svg" alt="" />{error.role_name}</span> )} 
                        <div className="form-group" style={formGroup}>
                          <label htmlFor="new_id" style={formLabel}>新帳號</label>
                          <input id="new_id" name="new_id" type="text" className="form-control" style={formControlStatic} value={new_id} onChange={this.onChange} />
                        </div>
                        <div className="tooltip1"><img src="../img/unknown.png" />
                          <span className="tooltiptext">{"請填寫您欲將找回的角色，綁定到哪一個遊戲內帳號ID。請正確填寫的帳號ID，已綁定好社群平台。帳號ID可至遊戲內開始畫面>右上角使用者中心>查看使用者中心左上角之帳號ID"}</span>
                        </div>
                        {error.new_id && (
                          <span className="wrong_msg" style={errorSpan2}><img src="../img/icon_wrong.svg" alt="" />{error.new_id}</span> )} 
                        <div className="form-group" style={{ ...formGroup, marginTop: "-20px"}}>
                          <label htmlFor="file" style={formLabel}>附圖</label>
                          <input className="form-control-static" type="file" id="file" name="file" style={formControlFile} accept="image/gif,image/jpeg,image/png" onChange={this.onChange} />
                        </div>
                        {error.file && (
                          <span className="wrong_msg" style={{textAlign: "left", margin: "-40px 0 0 100px"}}><img src="../img/icon_wrong.svg" alt="" />{error.file}</span> )} 
                        <p className="t1" style={{color: "#000", fontWeight: "600", textAlign: "left", marginLeft: "30px"}}>* 請提供完成創角並成功綁定的新帳號使用者中心截圖。<a href="/members/img/a21c467af2bfa65b.png" target="_blank" rel="noopener noreferrer" style={{color: "red", backgroundColor: "yellow"}}>點我看範例</a><br />
                        * 本服務同一角色30天內僅可申請一次。</p>
                        <div className="form-group" style={formGroup}>
                          <button type="button" className="btn btn-danger btn-block" onClick={this.onClick}>
                          <a href="" style={{color: "#fff", textDecoration: "none", fontSize: "1.5rem"}}>申請找回</a>
                          </button>
                        </div>
                        <div className="form-group" style={formGroup}>
                          <button type="button" className="btn btn-primary btn-block">
                          <a href="/members/bind" style={{color: "#fff", textDecoration: "none", fontSize: "1.5rem"}}>返回遊戲綁定</a>
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
              </div>
            </div>
          </div>

          <div className="container mt-3">
            <div className={`modal ${showModal}`} id="myModal" tabIndex="-1" aria-labelledby="myModalLabel" aria-hidden="true">
              <div className="modal-dialog" style={{width: "350px",margin: "250px auto"}}>
                  <div className="modal-content"> 
                      <div className="modal-body"> <img className="icon" src="img/check.png" alt="" />
                          <h3>帳號找回申請已發送成功</h3>
                          <br />
                          <p style={{textAlign: "left", marginLeft: "20px", fontSize: "16px"}}>
                          您提出的帳號找回申請我們收到了，請您稍加等待我們處理審閱，完成找回將會再次發送郵件與會員中心通知消息給您，謝謝。
                          </p>
                      </div>
                      <div className="modal-footer" style={{textAlign: "center", border: "0"}}>
                          <button type="button" className="btn btn-danger" data-bs-dismiss="modal" onClick={this.handleCloseModal}>完成</button>
                      </div>
                  </div>
              </div>
            </div>
          </div>

          <Footer />
          <div className={showModalBackdrop}></div>
        </div>
        )}
      </Fragment>
    );
  }
}

RetrieveAccount.propTypes = {
  getMemberActionIsRead: PropTypes.func.isRequired,
  getBinding: PropTypes.func.isRequired,
  retrieveAccount: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  isRead: state.member.isRead,
  binding: state.bind.binding,
  errors: state.errors,
  result: state.bind.retrieveAccountResult,
});

export default connect(mapStateToProps, { getBinding, retrieveAccount, getMemberActionIsRead })(RetrieveAccount);